import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shirt } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Merch() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    document.title = "Merch | Card Lobster";
    Promise.all([
      api.get("/products?category=merch"),
      api.get("/settings"),
    ])
      .then(([p, s]) => { setItems(p.data); setSettings(s.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const kicker = settings.merch_kicker || "Card Lobster";
  const title = settings.merch_title || "Official Merch";
  const subtitle = settings.merch_subtitle || "Tees, snapbacks, and Lobster5 gear for the crew.";

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16" data-testid="merch-page">
      <div className="max-w-3xl">
        <div className="flex items-center gap-3 text-label text-[var(--cl-primary)]">
          <Shirt size={16} /> <span>{kicker}</span>
        </div>
        <h1 className="font-display text-5xl sm:text-7xl mt-2">{title}</h1>
        <p className="text-zinc-300 text-lg mt-4">{subtitle}</p>
      </div>

      <div className="mt-12">
        {loading && <div className="text-zinc-500 text-sm">Loading merch…</div>}
        {!loading && items.length === 0 && (
          <div className="border border-dashed border-white/10 rounded-lg py-20 text-center" data-testid="merch-empty">
            <Shirt size={40} className="mx-auto text-[var(--cl-orange)]" />
            <h2 className="font-display text-3xl mt-4">Nothing dropped yet</h2>
            <p className="text-zinc-400 text-sm mt-3 max-w-md mx-auto">
              First tee coming soon. Follow the live streams or grab a mystery pack while you wait.
            </p>
            <div className="flex flex-wrap justify-center gap-3 mt-6">
              <Link to="/shop" className="btn-primary">Shop Cards</Link>
              <Link to="/live" className="btn-outline">Watch Live</Link>
            </div>
          </div>
        )}
        {!loading && items.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="merch-grid">
            {items.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>
    </div>
  );
}
